module.exports = __webpack_public_path__ + "static/media/up.28d27e46.svg";